export const twilioErrorCode = (err: unknown): number | undefined => {
  if (err === null || typeof err !== 'object') {
    return undefined;
  }
  const { code } = err as { code?: unknown };
  return typeof code === 'number' && Number.isFinite(code) ? code : undefined;
};
